const normalizeIntegrationUrl = (value?: string): string | null => {
    const trimmed = value?.trim();
    if (!trimmed) return null;
    return trimmed.endsWith('/') ? trimmed : `${trimmed}/`;
};

const normalizeCookieDomains = (domains: string[]): string[] =>
    Array.from(
        new Set(
            domains
                .map((domain) => domain.trim().toLowerCase())
                .filter((domain) => !!domain && domain !== 'localhost' && domain !== '127.0.0.1'),
        ),
    );

export const awsWafDomainMatchesHostname = (hostname: string, domain: string): boolean =>
    hostname === domain || hostname.endsWith(`.${domain}`);

const getHostname = (value?: string | null): string | null => {
    if (!value) return null;
    try {
        return new URL(value).hostname;
    } catch {
        return null;
    }
};

export interface AwsWafClientConfigParams {
    baseUrl?: string;
    exchangeApiUrl?: string;
    integrationUrl?: string;
    cookieDomainList?: string;
    fetchRetryCount?: number;
    maxTokenAgeMs?: number;
    currentHostname?: string | null;
}

export interface AwsWafClientConfig {
    integrationUrl: string | null;
    cookieDomains: string[];
    fetchRetryCount?: number;
    maxTokenAgeMs?: number;
}

export const getAwsWafClientConfig = (params: AwsWafClientConfigParams): AwsWafClientConfig => {
    const integrationUrl = normalizeIntegrationUrl(params.integrationUrl);
    const explicitDomains = params.cookieDomainList
        ? params.cookieDomainList
              .split(',')
              .map((domain) => domain.trim())
              .filter((domain) => !!domain)
        : [];

    const fallbackDomains = [
        getHostname(params.baseUrl),
        getHostname(params.exchangeApiUrl),
        params.currentHostname,
    ].filter((domain): domain is string => !!domain);

    return {
        integrationUrl,
        cookieDomains: normalizeCookieDomains(explicitDomains.length > 0 ? explicitDomains : fallbackDomains),
        fetchRetryCount: params.fetchRetryCount && params.fetchRetryCount > 0 ? params.fetchRetryCount : undefined,
        maxTokenAgeMs: params.maxTokenAgeMs && params.maxTokenAgeMs > 0 ? params.maxTokenAgeMs : undefined,
    };
};
